






































































































































































import {
  Component,
  Prop,
  PropSync,
  Model,
  Vue,
  Watch,
} from 'vue-property-decorator'
import HdsIcon, { HADES_ICON_SIZE } from '@/components/HdsIcon.vue'
import HdsBtn, { HADES_BTN_SIZE } from '@/components/HdsBtn.vue'
import hash from '@/utils/hash'
import HdsChip from '@/components/HdsChip.vue'
import Draggable from 'vuedraggable'

export const HADES_TEXT_FIELD_TYPE = {
  DEFAULT: 'default',
  OUTLINED: 'outlined',
  SOLO: 'solo',
}

@Component({
  components: { HdsChip, HdsIcon, HdsBtn, Draggable },
})
export default class HdsTextField extends Vue {
  name: string = 'HdsTextField'
  hash: string = hash(8)
  focused: boolean = false
  showPassword: boolean = false
  error: string = ''

  HADES_ICON_SIZE = HADES_ICON_SIZE
  HADES_BTN_SIZE = HADES_BTN_SIZE

  get isFocused() {
    return this.focused || this.forceFocused
  }

  get dragOptions() {
    return {
      animation: 300,
      handle: '.hds-chip',
      group: 'selectedItems',
      disabled: !this.allowSort,
      ghostClass: 'ghost',
      sort: this.allowSort,
    }
  }

  /**
   * Events
   */
  @Watch('value')
  onWatchValue(value: string, old: string) {
    if (value === old) return
    if ((this.$refs.input as any)._inputAutoWidth) {
      ;(this.$refs.input as any)._inputAutoWidth(value)
    }
  }

  onMove(evt: any) {
    if (!evt.relatedContext.element) return false
    return true
  }

  onInput(value: string) {
    this.$emit('input', value)
  }

  onKeypress(e: Event) {
    this.$emit('keypress', e)
  }

  onKeydown(e: Event) {
    this.$emit('keydown', e)
  }

  onKeyup(e: Event) {
    this.$emit('keyup', e)
  }

  onFocus(e: Event) {
    this.$emit('focus', e)
    this.focused = true
  }

  onBlur(e: Event) {
    this.$emit('blur', e)
    this.focused = false
  }

  onClickClear() {
    this.$emit('input', '')
  }

  onMousedownClose(evt: Event & any, item: any) {
    evt.value = item
    this.$emit('mousedown:close', evt)
  }

  onMouseupClose(evt: Event & any, item: any) {
    evt.value = item
    this.$emit('mouseup:close', evt)
  }

  onClickClose(evt: Event & any, item: any) {
    evt.value = item
    this.$emit('click:close', evt)
  }

  onClickSelectedItem(evt: Event & any, item: any) {
    evt.value = item
    this.$emit('click:selectedItem', evt)
  }

  onClickPrependOuterIcon() {
    this.$emit('click:prepend-outer-icon')
  }

  onClickPrependIcon() {
    this.$emit('click:prepend-icon')
  }

  onClickAppendIcon() {
    this.$emit('click:append-icon')
  }

  onClickAppendOuterIcon() {
    this.$emit('click:append-outer-icon')
  }

  onClickTextField(evt: Event) {
    this.$emit('click', evt)
  }

  onClickMenuBtn(evt: Event) {
    this.$emit('click:menu-btn', evt)
  }

  onMousedownTextField(evt: Event) {
    this.$emit('mousedown', evt)
  }

  onMouseupTextField(evt: Event) {
    this.$emit('mouseup', evt)
  }

  /**
   * input value for v-model
   */
  @Model('input', { default: '' }) value!: string

  /**
   * ORIGINAL selected items for Select component
   */
  @PropSync('selectedItems', { type: Array, default: () => [] })
  selectedItemsSync!: any[]

  /**
   * OBJECT PARSED selected items for Select component
   */
  @PropSync('parsedSelectedItems', { type: Array, default: () => [] })
  parsedSelectedItemsSync!: any[]

  /**
   * **DO-NOT-USE**
   * select 에서 사용되는 dropdown 열렸는지 닫혔는지
   */
  @PropSync('on', { type: Boolean, default: false }) onSync!: boolean

  /**
   * **DO-NOT-USE**
   * select 인지 평범한 text-field 인지
   */
  @Prop({ type: Boolean, default: false }) isSelect!: boolean

  /**
   * UI Type.
   */
  @Prop({ type: String, default: 'default' }) type!: string

  /**
   * Dense (smaller ui)
   */
  @Prop({ type: Boolean }) dense?: boolean

  /**
   * 테두리 색을 지정합니다.
   */
  @Prop({ type: String }) borderColor?: string

  /**
   * 배경 색을 지정합니다.
   */
  @Prop({ type: String }) backgroundColor?: string

  /**
   * Label text
   */
  @Prop({ type: String, default: '' }) label!: string

  /**
   * Placeholder value
   */
  @Prop({ type: String, default: '' }) placeholder!: string

  /**
   * hint value
   */
  @Prop({ type: String }) hint?: string

  /**
   * 힌트를 고정합니다.
   */
  @Prop({ type: Boolean, default: false }) persistentHint!: boolean

  /**
   * 카운터 값
   */
  @Prop({ default: false }) counter?: number | boolean

  /**
   * max-length, 0: no limit
   */
  @Prop({ type: Number, default: 0 }) maxLength!: number

  /**
   * Input minimum width
   */
  @Prop({ type: String, default: '10px' }) inputMinWidth!: string

  /**
   * 카운터를 고정합니다.
   */
  @Prop({ type: Boolean, default: false }) persistentCounter!: boolean

  /**
   * 비밀번호를 입력할떄 사용합니다. 인풋이 가려집니다.
   */
  @Prop({ type: Boolean, default: false }) password!: boolean

  /**
   * Footer를 표시하지 않습니다.
   */
  @Prop({ type: Boolean, default: false }) hideFooter!: boolean

  /**
   * enable clear
   */
  @Prop({ type: Boolean, default: false }) clear!: boolean

  /**
   * disabled
   */
  @Prop({ type: Boolean, default: false }) disabled!: boolean

  /**
   * readonly
   */
  @Prop({ type: Boolean, default: false }) readonly!: boolean

  /**
   * prefix
   */
  @Prop({ type: String, default: '' }) prefix!: string

  /**
   * suffix
   */
  @Prop({ type: String, default: '' }) suffix!: string

  /**
   * icon password on
   */
  @Prop({ type: String, default: 'eye' }) iconPasswordOn!: string

  /**
   * icon password off
   */
  @Prop({ type: String, default: 'eye-off' }) iconPasswordOff!: string

  /**
   * icon clear
   */
  @Prop({ type: String, default: 'close' }) iconClear!: string

  /**
   * prepend icon value
   */
  @Prop({ type: String }) prependIcon?: string

  /**
   * append icon value
   */
  @Prop({ type: String }) appendIcon?: string

  /**
   * outer prepend icon value
   */
  @Prop({ type: String }) prependOuterIcon?: string

  /**
   * outer append icon value
   */
  @Prop({ type: String }) appendOuterIcon?: string

  /**
   * cursor and ripple animation for prepend icon value
   */
  @Prop({ type: Boolean, default: false }) ripplePrependIcon?: boolean

  /**
   * cursor and ripple animation for append icon value
   */
  @Prop({ type: Boolean, default: false }) rippleAppendIcon?: boolean

  /**
   * cursor and ripple animation for outer prepend icon value
   */
  @Prop({ type: Boolean, default: false }) ripplePrependOuterIcon?: boolean

  /**
   * cursor and ripple animation for outer append icon value
   */
  @Prop({ type: Boolean, default: false }) rippleAppendOuterIcon?: boolean

  /**
   * rules
   */
  @Prop({ default: () => [] }) rules!: any[]

  /**
   * **DO-NOT-USE**
   * hds-select 에서 사용되는 chip
   */
  @Prop({ type: Boolean, default: false }) chipClose!: boolean

  /**
   * 드래그 앤 드롭으로 정렬 가능
   */
  @Prop({ type: Boolean, default: false }) allowSort!: boolean

  /**
   * 선택된 아이템이 많아도 한줄로 표시
   */
  @Prop({ type: Boolean, default: false }) singleLine!: boolean

  /**
   * force focused
   */
  @Prop({ type: Boolean, default: false }) forceFocused!: boolean

  /**
   * 아이템이 오브젝트일때,
   * 아이템 text 키.
   */
  @Prop({ type: String, default: 'text' }) itemText!: string

  /**
   * 아이템이 오브젝트일때,
   * 아이템 value 키.
   */
  @Prop({ type: String, default: 'value' }) itemValue!: string

  @Prop({ default: null }) highlightedIndex!: null | number

  /**
   * hide menu btn
   */
  @Prop({ type: Boolean, default: false }) hideMenuBtn!: boolean

  mounted() {
    this.onChangeValue(this.value)
  }

  @Watch('value')
  onChangeValue(value: any) {
    if (this.maxLength > 0 && this.value.length > this.maxLength)
      this.$emit('input', this.value.slice(0, this.maxLength))
    this.error = this.validateRules(value, this.rules)
  }

  validateRules(value: any, rules: any[]): string {
    if (typeof this.counter === 'number' && value.length > this.counter)
      return `Max ${this.counter} characters`

    for (let i = 0; i < rules.length; i++) {
      if (rules[i](value) !== true) return rules[i](value)
    }
    return ''
  }

  get isDefault(): boolean {
    return this.type === HADES_TEXT_FIELD_TYPE.DEFAULT
  }

  get isOutlined(): boolean {
    return this.type === HADES_TEXT_FIELD_TYPE.OUTLINED
  }

  get isSolo(): boolean {
    return this.type === HADES_TEXT_FIELD_TYPE.SOLO
  }

  get containerClasses() {
    return {
      'hds-container': true,
      'hds-default': this.isDefault,
      'hds-default--disabled': this.isDefault && this.disabled,
      'hds-default--error': !!this.error,
      'hds-outlined': this.isOutlined,
      'hds-outlined--disabled': this.isOutlined && this.disabled,
      'hds-outlined--focus':
        this.isFocused && this.isOutlined && !this.isSolo,
      'hds-solo': this.isSolo,
      'hds-container--disabled': this.disabled,
      // 'overflow-x-auto': this.singleLine,
    }
  }

  get containerStyles() {
    const result: any = {}
    if (this.isOutlined && this.isFocused)
      result['--tw-ring-color'] = this.borderColor
    if (!this.isOutlined || (this.isOutlined && !this.label))
      result['backgroundColor'] = this.backgroundColor
    if (this.error) result['--tw-ring-color'] = 'red'
    return result
  }

  get borderBottomClasses() {
    return {
      'hds-border-bottom--ready': this.isDefault,
      'hds-border-bottom--focus': this.isDefault && this.isFocused,
    }
  }

  get borderBottomStyles() {
    return {
      borderBottomColor: this.error ? 'red' : this.borderColor,
    }
  }

  get labelClasses() {
    return {
      'hds-label': true,
    }
  }

  get iconClasses() {
    return {
      'hds-icon': true,
    }
  }

  get clearButtonClasses() {
    return {
      'hds-clear-button': true,
    }
  }

  get labelTextClasses() {
    return {
      'hds-label-text': true,
      'hds-label-text--default--valued': this.isDefault && this.value,
      'hds-label-text--default--focus': this.isDefault && this.isFocused,
      'hds-label-text--outlined--valued': this.isOutlined && this.value,
      'hds-label-text--outlined--focus': this.isOutlined && this.isFocused,
      'hds-label-text--solo--focus':
        this.isSolo && (this.isFocused || this.value),
    }
  }

  get labelTextStyles() {
    return {
      color: this.error ? 'red' : this.borderColor,
    }
  }

  get chipClasses() {
    return (index: number) => ({
      'cursor-move': this.allowSort,
      'hds-highlight': this.highlightedIndex === index,
    })
  }

  get inputClasses() {
    return {
      'input--default--focus':
        this.isDefault && (this.isFocused || this.value) && this.label,
      'hds-dense': this.dense,
      'input--readonly': this.readonly,
      '-ml-3': this.parsedSelectedItemsSync.length === 0,
    }
  }

  get inputStyles() {
    return {
      minWidth: this.inputMinWidth,
    }
  }

  get chipContainerClasses() {
    return {
      'hds-chip-container': true,
      'hds-chip-container--single-line': this.singleLine,
    }
  }

  get hintClasses() {
    return {
      'hds-hint': true,
      'hds-hint--focus': this.isFocused || this.persistentHint,
      'hds-hint--error': this.error.length > 0,
    }
  }

  get counterClasses() {
    return {
      'hds-counter': true,
      'hds-counter--focus': this.isFocused || this.persistentCounter,
      'hds-counter--overflow':
        typeof this.counter === 'number' && this.value.length > this.counter,
    }
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword
  }

  focus() {
    ;(this.$refs.input as HTMLInputElement).focus()
  }
}
